'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp; // import Autosuggest from 'react-autosuggest'


// import Helmet from 'react-helmet'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactSlidedown = require('react-slidedown');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _components = require('../../components');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanySectors = require('../../data/CompanySectors.json');
var FundFamilyPetitions = require('../../data/FundFamilyPetitions.json');

var Styles = require('./Fund.css');
var MaxPerPage = 5;


function mapFundHoldings(fHoldings) {
  var fHoldingsMap = {};
  fHoldings.forEach(function (fholding) {
    fHoldingsMap[fholding.db_holding_id] = fholding;
  });
  return fHoldingsMap;
}
function filterHoldings(fHoldingsMap, holdings, filterFn) {
  return (0, _lodash.chain)(holdings).filter(filterFn).sortBy(function (o) {
    return fHoldingsMap[o.id].market_value * -1;
  })
  // .take(10)
  .value();
}

var Fund = (_dec = (0, _reactRedux.connect)(function (state) {
  return { result: state.shareClass.result,
    loading: state.shareClass.loading, loaded: state.shareClass.loaded, error: state.shareClass.error };
}, searchActions), _dec2 = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: function promise(_ref) {
    var params = _ref.params,
        _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId));
  }
}]), _dec3 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Fund, _Component);

  function Fund(props) {
    (0, _classCallCheck3.default)(this, Fund);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Fund.__proto__ || (0, _getPrototypeOf2.default)(Fund)).call(this, props));

    _this.handleScroll = function () {
      if (!_this._mounted) {
        return;
      }
      if (!_this.props.result) {
        return;
      }
      var shareClass = _this.props.result.shareClass;

      var name = shareClass.fund_family_name;
      var scrollTop = event.srcElement.body.scrollTop;
      var isSelectFamily = _config2.default.familyFunds.find(function (fam) {
        return fam.name === name;
      });
      var hasScrolled = scrollTop > window.innerHeight;
      // if user has scrolled, and modal is not already shown, and it's one of
      // the selected families: open the modal via set state
      if (shareClass && hasScrolled && !_this.state.openModalShown && isSelectFamily) {
        _this.setState({ openModal: true, openModalShown: true });
      }
    };

    _this.scrollTo = function (id) {
      return function () {
        var ele = document.getElementById(id);
        window.scrollTo(ele.offsetLeft, ele.offsetTop);
      };
    };

    _this.clickViewMore = function () {
      _this.setState({ viewMore: !_this.state.viewMore });
    };

    _this.clickCloseModal = function () {
      _this.setState({ openModal: !_this.state.openModal });
    };

    _this.increment = function (incState) {
      return function () {
        var newState = {};
        newState[incState] = _this.state[incState] + 1;
        _this.setState(newState);
      };
    };

    _this.holdingsCount = function (count) {
      if (count > 0) return _format2.default.number(count) + ' HOLDINGS';
      return '';
    };

    _this.hasUssifBadge = function (ussif) {
      // true if fund gets ussif badge else false
      return _convert2.default.float(ussif) === 1.5;
    };

    _this.renderHoldings = function (shareClass, fHoldingsMap, holdings, page, type) {
      // if no holdings, return "no holdings" notice
      if (!holdings || holdings.length === 0) {
        return _react2.default.createElement(
          'div',
          { styleName: 'holdings-none' },
          'NONE'
        );
      }

      // icon images
      var iconPo = require('../../../static/images/icn-po.svg');
      var iconPp = require('../../../static/images/icn-pp.svg');
      var iconRb = require('../../../static/images/icn-rb.svg');
      var iconTb = require('../../../static/images/icn-tb.svg');
      var iconBf = require('../../../static/images/icn-bf.svg');
      var iconSy = require('../../../static/images/icn-sy.svg');
      var iconPoY = require('../../../static/images/icn-po-y.svg');
      var iconPpY = require('../../../static/images/icn-pp-y.svg');
      var iconRbY = require('../../../static/images/icn-rb-y.svg');
      var iconTbY = require('../../../static/images/icn-tb-y.svg');
      var iconBfY = require('../../../static/images/icn-bf-y.svg');
      var iconSyY = require('../../../static/images/icn-sy-y.svg');

      return (0, _lodash.chain)(holdings).take(page * MaxPerPage).map(function (holding, idx) {
        var flags = [];
        var c = CompanySectors.data[holding.company_id];
        if (type === 'producers') {
          if ((0, _lodash.includes)(c, 'is_sy_p')) {
            flags.push(['is_sy_p', iconSy, 'Soy producer']);
          }
          if ((0, _lodash.includes)(c, 'is_bf_p')) {
            flags.push(['is_bf_p', iconBf, 'Cattle producer']);
          }
          if ((0, _lodash.includes)(c, 'is_tb_p')) {
            flags.push(['is_tb_p', iconTb, 'Timber producer']);
          }
          if ((0, _lodash.includes)(c, 'is_rb_p')) {
            flags.push(['is_rb_p', iconRb, 'Rubber producer']);
          }
          if ((0, _lodash.includes)(c, 'is_pp_p')) {
            flags.push(['is_pp_p', iconPp, 'Paper/pulp producer']);
          }
          if ((0, _lodash.includes)(c, 'is_po_p')) {
            flags.push(['is_po_p', iconPo, 'Palm oil producer']);
          }
        }
        if (type === 'consumers') {
          if ((0, _lodash.includes)(c, 'is_sy_c')) {
            flags.push(['is_sy_c', iconSyY, 'Soy major consumer brand']);
          }
          if ((0, _lodash.includes)(c, 'is_bf_c')) {
            flags.push(['is_bf_c', iconBfY, 'Cattle major consumer brand']);
          }
          if ((0, _lodash.includes)(c, 'is_tb_c')) {
            flags.push(['is_tb_c', iconTbY, 'Timber major consumer brand']);
          }
          if ((0, _lodash.includes)(c, 'is_rb_c')) {
            flags.push(['is_rb_c', iconRbY, 'Rubber major consumer brand']);
          }
          if ((0, _lodash.includes)(c, 'is_pp_c')) {
            flags.push(['is_pp_c', iconPpY, 'Paper/pulp major consumer brand']);
          }
          if ((0, _lodash.includes)(c, 'is_po_c')) {
            flags.push(['is_po_c', iconPoY, 'Palm oil major consumer brand']);
          }
        }
        return _react2.default.createElement(
          'li',
          { key: idx, styleName: 'holding' },
          _react2.default.createElement(
            'div',
            { styleName: 'holding-name' },
            _react2.default.createElement(
              _components.CompanyProfileModal,
              { company_id: holding.company_id },
              idx + 1,
              '. ',
              holding.security_name
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-icon-holding-wrap visible-sm visible-md visible-lg' },
              /* one image per flag */
              flags.length > 0 ? flags.map(function (flag) {
                return _react2.default.createElement('img', {
                  key: flag[0],
                  styleName: 'detail-icon-holding',
                  src: flag[1],
                  alt: flag[2],
                  title: flag[2]
                });
              }) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-asset' },
            _react2.default.createElement(
              'span',
              { styleName: 'visible-sm visible-md visible-lg' },
              _format2.default.perc(fHoldingsMap[holding.id].scaled_weighting)
            ),
            _react2.default.createElement(
              'span',
              { styleName: 'visible-xs holding-asset-mobile' },
              _format2.default.perc(fHoldingsMap[holding.id].scaled_weighting),
              ' of portfolio'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-invested' },
            _react2.default.createElement(
              'span',
              { styleName: 'visible-sm visible-md visible-lg' },
              _format2.default.money(fHoldingsMap[holding.id].market_value, true, shareClass.currency, true)
            ),
            _react2.default.createElement(
              'span',
              { styleName: 'visible-xs holding-asset-mobile' },
              _format2.default.money(fHoldingsMap[holding.id].market_value, true, shareClass.currency, true),
              ' invested'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'detail-icon-holding-wrap visible-xs' },
            /* one image per flag */
            flags.length > 0 ? flags.map(function (flag) {
              return _react2.default.createElement('img', {
                key: flag[0],
                styleName: 'detail-icon-holding',
                src: flag[1],
                alt: flag[2],
                title: flag[2]
              });
            }) : null
          )
        );
      }).value();
    };

    _this.renderCompanies = function (shareClass, fHoldingsMap, type, label, count, holdings, page, text) {
      function hasMore() {
        if (!holdings || holdings.length === 0) {
          return false;
        }
        return page * MaxPerPage < holdings.length;
      }
      function moreCount() {
        if (!hasMore()) {
          return 0;
        }
        var diff = holdings.length - page * MaxPerPage;
        return diff > MaxPerPage ? MaxPerPage : diff;
      }

      var poIcon = require('../../../static/images/icn-' + type + '.svg');
      var hasMoreButton = hasMore(page, holdings) ? _react2.default.createElement(
        'div',
        {
          styleName: 'detail-more-' + type,
          onClick: _this.increment(type + 'Page')
        },
        'View next ',
        moreCount(),
        _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-down' })
      ) : null;

      count = _convert2.default.int(count);
      if (count === 0) {
        return _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 12 },
          _react2.default.createElement(
            'div',
            { styleName: 'detail-holdings-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-wrapper-empty' },
              _react2.default.createElement('img', {
                styleName: 'detail-icon-empty',
                src: poIcon,
                alt: 'No holdings icon' }),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-title-empty' },
                label
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-holdings-empty' },
                '0 HOLDINGS'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'detail-holdings-description-none' },
            text
          )
        );
      }
      return _react2.default.createElement(
        _reactFlexboxGrid.Col,
        { xs: 12, styleName: 'detail-holdings-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'detail-' + type },
          _react2.default.createElement('img', { styleName: 'po-icon', src: poIcon, alt: label }),
          _react2.default.createElement(
            'div',
            { styleName: 'detail-title-holdings' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-title-' + type },
              label
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'visible-sm visible-md visible-lg detail-holdings-count-' + type },
              _this.holdingsCount(count)
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'detail-holdings-description' },
            text
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'visible-xs mobile-holdings-label' },
            count,
            ' HOLDINGS'
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _react2.default.createElement(
              'ul',
              { styleName: 'detail-holdings' },
              _react2.default.createElement(
                'li',
                { styleName: 'holding' },
                _react2.default.createElement('div', { styleName: 'holding-name' }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'visible-sm visible-md visible-lg holding-asset' },
                  '% of portfolio'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'visible-sm visible-md visible-lg holding-invested' },
                  '$ invested'
                )
              ),
              _this.renderHoldings(shareClass, fHoldingsMap, holdings, page, type)
            )
          )
        ),
        hasMoreButton
      );
    };

    _this.renderStats = function (shareClass) {
      function renderCol(type, entries, hasLine) {
        return _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 6, styleName: 'col-' + type + '-wrapper' },
          /*  for each stat, it's either left or right, link or no link, and
              line or no line */
          entries.map(function (entry, idx) {
            var showLine = hasLine && idx !== entries.length - 1;
            return _react2.default.createElement(
              'div',
              { key: idx, styleName: 'col-label-value' },
              _react2.default.createElement(
                'div',
                { styleName: 'col-' + type },
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-label' },
                  entry.name
                ),
                entry.link ? _react2.default.createElement(
                  _components.Link,
                  { to: entry.link },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'stats-value-link' },
                    entry.value,
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                ) : _react2.default.createElement(
                  'div',
                  { styleName: 'stats-value' },
                  entry.value
                )
              ),
              showLine ? _react2.default.createElement('div', { styleName: 'col-line' }) : null
            );
          })
        );
      }
      var dest = encodeURIComponent(shareClass.fund_family_name);

      return _react2.default.createElement(
        'div',
        { styleName: 'stats' },
        _react2.default.createElement(
          'div',
          { styleName: 'stats-inner' },
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'stats-header' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 6 },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-title' },
                'Mutual fund profile'
              )
            ),
            shareClass.grade_deforestation ? _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 6 },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-score-label-score' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-score-label' },
                  'Deforestation grade'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-score-wrapper' },
                  _react2.default.createElement(_components.Grade, { grade: shareClass.grade_deforestation })
                )
              )
            ) : null
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Shareclass ticker', value: shareClass.ticker }], false),
            renderCol('right', [{ name: 'Data as of', value: (0, _moment2.default)(shareClass.date.slice(0, 10)).format('D MMM YYYY') }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Shareclass name', value: shareClass.name }], false),
            renderCol('right', [{ name: '% of fund assets screened', value: _format2.default.perc(shareClass.percent_rated) }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Shareclass type', value: _format2.default.legalType(shareClass.legal_type) }], false),
            renderCol('right', [{ name: 'Fund net assets', value: _format2.default.money(shareClass.fund_net_assets, true, shareClass.currency, true, 2) }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Fund family', link: _config2.default.routes.families + '?q=' + dest, value: shareClass.fund_family_name }], false),
            renderCol('right', [{ name: 'Category', value: shareClass.morningstar_category_name }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Country', value: _format2.default.market(shareClass.market) }], false),
            renderCol('right', [{ name: 'Currency', value: _format2.default.currencyCode(shareClass.currency) }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Non-diversification risk', value: _format2.default.boolean(shareClass.non_diversified_fund) }], false),
            renderCol('right', [{ name: 'Sustainability mandate', value: _format2.default.boolean(shareClass.socially_responsible_fund || "0") }], false)
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'stats-totals' },
            _react2.default.createElement(
              'div',
              { styleName: 'stats-totals-header' },
              'Totals'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total flagged holdings for all deforestation categories (commodity producers, banks and lenders, and major consumer brands)'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.number(shareClass.po_all_count)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total % of fund assets flagged for all deforestation categories'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.perc(shareClass.po_all_weight)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total fund assets invested in flagged companies'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.money(shareClass.po_all_asset, true, shareClass.currency, true, 2)
              )
            )
          ),
          _this.renderMoreButton(shareClass.date, false)
        )
      );
    };

    _this.renderMoreButton = function (portfolioDate, showDataAs) {
      var label = !_this.state.viewMore ? 'View more info' : 'View less';
      var faclassUpDown = _this.state.viewMore ? 'angle-up' : 'angle-down';
      return _react2.default.createElement(
        'div',
        { styleName: 'view-more-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'view-more', onClick: _this.clickViewMore },
          label,
          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-' + faclassUpDown })
        ),
        showDataAs ? _react2.default.createElement(
          'div',
          { styleName: 'view-more-data' },
          'DATA AS OF ',
          (0, _moment2.default)(portfolioDate.slice(0, 19)).format('D MMM YYYY')
        ) : null
      );
    };

    _this.renderTakeAction = function (shareClass) {
      function renderAction(info, button, link, log) {
        return _react2.default.createElement(
          'div',
          { styleName: 'take-action-action' },
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-info' },
            info
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-button-wrap' },
            _react2.default.createElement(
              _components.Link,
              { to: link, log: log, title: button },
              _react2.default.createElement(
                'div',
                { styleName: 'take-action-button' },
                button
              )
            )
          )
        );
      }

      var fund_id = shareClass.fund_id,
          investment_vehicle_id = shareClass.investment_vehicle_id,
          ticker = shareClass.ticker;

      var fffRoute = _config2.default.links.fffFund + '/' + fund_id + '/' + investment_vehicle_id + '/' + (ticker || '');

      return _react2.default.createElement(
        'div',
        { styleName: 'take-action-wrap' },
        _react2.default.createElement('div', { styleName: 'take-action-anchor', id: 'take-action' }),
        _react2.default.createElement(
          'div',
          { styleName: 'take-action' },
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'take-action-header' },
              'Take Action'
            ),
            _react2.default.createElement('div', { styleName: 'take-action-line' }),
            renderAction('Call on U.S. investment firms to implement Deforestation ' + 'and Land Grab-Free investment policies.', 'SUPPORT THE PETITION', _config2.default.routes.petitions),
            renderAction('Find top-graded funds that avoid deforestation-risk ' + 'investments.', 'FIND TOP-SCORING FUNDS', _config2.default.routes.clean),
            renderAction('Use Fossil Free Funds to check this fund\'s fossil fuel ' + 'investments and carbon footprint.', 'CHECK FOR FOSSIL FUELS', fffRoute, _analytics2.default.eventToFFF(fund_id, investment_vehicle_id))
          )
        )
      );
    };

    _this.renderMore = function (shareClass, showDataAs) {
      return _react2.default.createElement(
        'div',
        { styleName: 'more-stats' },
        _this.renderMoreButton(shareClass.date, true),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          _this.state.viewMore ? _this.renderStats(shareClass) : null
        )
      );
    };

    _this.renderUssifBadge = function () {
      var ussifLogo = require('../../../static/images/ussif-logo.png');
      var ussifAlt = 'Member of The Forum for Sustainable and Responsible' + 'Investment icon';
      var linkTitle = 'US-SIF: Forum for Sustainable and Responsible Investment';
      return _react2.default.createElement(
        _reactFlexboxGrid.Row,
        null,
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 12, styleName: 'ussif-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'ussif-badge-info' },
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-title' },
              'Member of the Forum for Sustainable and Responsible Investment'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-info' },
              'This asset manager is a member of the Forum for Sustainable and Responsible Investment, a group advancing sustainable, responsible, and impact investing.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-subtitle' },
              'Learn more:\xA0',
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.ussif,
                  xstrong: true,
                  title: linkTitle
                },
                'Forum for Sustainable and Responsible Investment'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ussif-img-wrap' },
            _react2.default.createElement('img', {
              styleName: 'ussif-badge-img',
              src: ussifLogo,
              alt: ussifAlt
            })
          )
        )
      );
    };

    _this.renderEngagementStatement = function (shareClass) {
      // filter engagement families from config to see if this family is
      // eligible for a statement box
      var engageFam = _config2.default.engagementFunds.find(function (family) {
        return family.name === shareClass.fund_family_name;
      });
      var dffGrade = shareClass.grade_deforestation;
      var hasEngageGrade = dffGrade === 1.5;
      var isSri = _convert2.default.boolean(shareClass.socially_responsible_fund);
      // exit if it's not an engagement family
      if (!((engageFam || hasEngageGrade) && isSri)) {
        return null;
      }
      // otherwise, check for SRI. only show the statement if family is engager,
      // has statement, and fund is SRI
      // encode URI since family names have special chars
      var dest = engageFam ? encodeURIComponent(engageFam.name) : '';
      return _react2.default.createElement(
        'div',
        { styleName: 'engagement-statement-container' },
        _react2.default.createElement(
          'div',
          { styleName: 'engagement-statement-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'engagement-statement' },
            _react2.default.createElement(
              'div',
              { styleName: 'engagement-statement-grade-wrapper' },
              _react2.default.createElement(_components.Grade, { grade: 1.5, large: true })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'engagement-statement-title' },
              'Known Sustainability Engager'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Some sustainability-mandated funds actively engage the companies they own. Indeed, efforts by sustainability-focused investors whose funds are found on this site have been crucial to driving positive change in deforestation-risk sectors like palm oil. A number of asset managers are ',
              _react2.default.createElement(
                'strong',
                null,
                'known sustainability engagers'
              ),
              ', and have taken actions such as filing\xA0',
              _react2.default.createElement(
                _components.Link,
                {
                  xstrong: true,
                  to: _config2.default.links.aysvote,
                  title: 'Vote Your Shares | As You Sow'
                },
                'shareholder resolutions'
              ),
              '\xA0asking for policy changes. Those asset managers deserve special acknowledgement - often, they are using their investments to make sure they have a voice at the table to call for real improvements in company behavior. We used\xA0',
              _react2.default.createElement(
                _components.Link,
                {
                  xstrong: true,
                  to: _config2.default.links.ceres,
                  title: 'Ceres Shareholder Resolution Database'
                },
                'data collected by Ceres'
              ),
              '\xA0to identify asset managers that have filed shareholder resolutions on deforestation, climate change, or other environmental issues. If a fund owns companies we screen for, but the family is a known filer of deforestation or environmental-related shareholder resolutions, it earns a special engagement score.\xA0',
              _react2.default.createElement(
                _components.Link,
                {
                  xstrong: true,
                  to: _config2.default.routes.faq + '#7',
                  title: 'FAQs | Deforestation Free Funds'
                },
                'Read more about our deforestation grades.'
              )
            ),
            /* if there is a list of companies filed at */
            engageFam.filedAt ? _react2.default.createElement(
              'p',
              null,
              engageFam.name,
              ' has filed deforestation or other climate-change related shareholder resolutions at ',
              _react2.default.createElement(
                'strong',
                null,
                engageFam.filedAt
              ),
              '\xA0',
              _react2.default.createElement(
                _components.Link,
                {
                  xstrong: true,
                  to: _config2.default.links.ceres,
                  title: 'Ceres Shareholder Resolutions Database'
                },
                'See the resolutions',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            ) : null,
            /* if there is an engagement statement */
            engageFam.statement ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { styleName: 'engagement-statement-title' },
                engageFam.name,
                ' submitted a statement describing their engagement efforts:'
              ),
              _react2.default.createElement(
                'blockquote',
                { styleName: 'engagement-statement-quote' },
                engageFam.statement
              )
            ) : null
          )
        )
      );
    };

    _this.renderGraphicBanner = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'banner-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'banner-taglines' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  'LET\'S USE OUR'
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  'PERSONAL ECONOMIC POWER'
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  'TO DEFUND DEFORESTATION.'
                )
              )
            )
          )
        )
      );
    };

    _this.state = {
      openModal: false,
      producersPage: 1,
      banksPage: 1,
      consumersPage: 1,
      viewMore: false,
      openModalShown: false
    };
    return _this;
  }

  (0, _createClass3.default)(Fund, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._mounted = true;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
      var _props$params = this.props.params,
          fundId = _props$params.fundId,
          investmentVehicleId = _props$params.investmentVehicleId;

      _analytics2.default.event(_analytics2.default.eventLoadFund(fundId, investmentVehicleId));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._mounted = false;
    }

    // deprecated


    // need this solution since asyncConnect and anchor links does not play nice

  }, {
    key: 'render',
    value: function render() {
      // it no results, show a loader
      // else, if results, but no fund found, redirect to the 404 page
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
        );
      } else if (this.props.result && (!this.props.result.fund || !this.props.result.shareClass)) {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
        );
      }

      function renderGradeBox() {
        // filter engagmentFamilies - if family returned, this shareclass
        // offered by engager
        var isEngagefam = _config2.default.engagementFunds.find(function (family) {
          return family.name === shareClass.fund_family_name;
        });
        // only show the notice if both engager and also SRI fund
        // (e.g. no non-SRI engagers)
        var isSri = _convert2.default.boolean(fund.socially_responsible_fund);
        var getsEngagementNotice = isEngagefam && isSri;
        // encode URI since family names have special chars
        var dest = isEngagefam ? encodeURIComponent(isEngagefam.name) : '';
        var letterGrade = _format2.default.score(fund.grade_deforestation);
        var sfGrade = letterGrade === 'N/A' ? 'NA' : letterGrade;

        var descriptions = {
          A: 'No holdings flagged for our deforestation screens. Assigned a grade of A.',
          E: 'Err-e',
          B: 'Fund is invested in deforestation-risk banks and lenders and/or major consumer brands, but no holdings flagged for our deforestation-risk agricultural commodity producer/trader screen. Assigned a grade of B.',
          C: 'Fund is invested in deforestation-risk agricultural commodity producer/traders, below the threshold of 0.5%. Assigned a grade of C.',
          D: 'Fund is invested in deforestation-risk agricultural commodity producer/traders, above the threshold of 0.5% and below 1.5%. Assigned a grade of D.',
          F: 'Fund is invested in deforestation-risk agricultural commodity producer/traders, above the threshold of 1.5%. Assigned a grade of F.',
          NA: 'Error'
        };
        var description = descriptions[sfGrade];

        return _react2.default.createElement(
          'div',
          { styleName: 'grade-snapshot' },
          /* either show an engagement grade notice, or a letter grade */
          getsEngagementNotice ? _react2.default.createElement(
            'div',
            { styleName: 'grade-engagement' },
            _react2.default.createElement(
              'div',
              { styleName: 'grade-intro' },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Engagement grade:'
                ),
                ' This fund family frequently engages the companies it invests in to push for better behavior.'
              ),
              '\xA0',
              _react2.default.createElement(
                _components.Link,
                {
                  strong: true,
                  to: _config2.default.routes.families + '?q=' + dest
                },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Learn more about engagement and socially responsible investing.'
                )
              )
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'grade-intro' },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Deforestation grade:'
                ),
                ' ',
                description
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                _components.Link,
                { strong: true, to: _config2.default.routes.faq + '#7' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'How we track deforestation-risk investments',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'grade-wrapper' },
            _react2.default.createElement(_components.Grade, { grade: fund.grade_deforestation, large: true })
          ),
          _react2.default.createElement(_reactTooltip2.default, null)
        );
      }

      function getPerc(asset, totalAsset) {
        asset = _convert2.default.int(asset);
        totalAsset = _convert2.default.int(totalAsset);
        if (totalAsset === 0) {
          return 0;
        }
        // return Math.round( asset/ totalAsset * 100 ) / 100
        return parseFloat((asset / totalAsset * 100).toFixed(2));
      }

      // images
      var producersIcon = require('../../../static/images/icn-producers.svg');
      var banksIcon = require('../../../static/images/icn-banks.svg');
      var consumersIcon = require('../../../static/images/icn-consumers.svg');

      var url = _config2.default.domain + this.props.location.pathname;
      var _props$result = this.props.result,
          shareClass = _props$result.shareClass,
          fund = _props$result.fund;
      var holdings = fund.holdings,
          fundholdings = fund.fundholdings,
          fund_family_name = fund.fund_family_name;

      var name = fund.fund_legal_name;
      var helmetTitle = 'Deforestation Free Funds results for ' + name;
      var producerPerc = getPerc(fund.po_producer_asset, fund.fund_net_assets);
      var bankPerc = getPerc(fund.po_financier_asset, fund.fund_net_assets);
      var consumerPerc = getPerc(fund.po_consumer_asset, fund.fund_net_assets);
      var dffPerc = getPerc(fund.po_all_asset, fund.fund_net_assets);
      var ownsProducers = fund.po_producer_asset > 0;
      var ownsBanks = fund.po_financier_asset > 0;
      var ownsConsumers = fund.po_consumer_asset > 0;
      var color = 'cblack';
      if (!ownsProducers && !ownsBanks && !ownsConsumers) {
        color = 'cgreen';
      } else if (!ownsProducers && (ownsBanks || ownsConsumers)) {
        color = 'cltgreen';
      } else if (ownsProducers) {
        color = 'credorange';
      }
      var fHoldingsMap = mapFundHoldings(fundholdings);
      var producerHoldings = filterHoldings(fHoldingsMap, holdings, function (o) {
        return o.is_po_producer;
      });
      var financierHoldings = filterHoldings(fHoldingsMap, holdings, function (o) {
        return o.is_po_financier;
      });
      var consumerHoldings = filterHoldings(fHoldingsMap, holdings, function (o) {
        return o.is_po_consumer;
      });

      var familiesWithPetitions = (0, _keys2.default)(FundFamilyPetitions.data);
      var hasPetition = familiesWithPetitions.indexOf(fund_family_name) >= 0;
      var entry = hasPetition ? FundFamilyPetitions.data[fund_family_name] : null;
      var petitionLink = entry ? entry[0] : null;
      var petitionText = entry ? entry[1] : null;
      var defaultCopy = 'Major fund managers invest millions into agricultural commodity producers and traders with business models that destroy the rainforest, and billions more into the banks and lenders that finance deforestation-risk producers, and the consumer brands that use these unsustainably-produced commodities in their products. Click below to learn more about the impact of agricultural commodity production on global rainforests.';
      var buttonText = petitionLink ? 'Sign the petition' : 'Learn more';

      var producersText = 'Companies that produce and trade palm oil, paper/pulp, rubber, timber, cattle, and soy, and have a past record or a significant risk of contributing to deforestation, land grabbing, and human rights abuses. Investing in any of these companies assigns a fund a grade of C if total producer exposure is below the threshold of 0.5%; a grade of D if below 1.5%; and a grade of F if above 1.5%.';
      var financierText = 'Financial institutions directly and indirectly involved in underwriting and lending to deforestation-risk producers and traders. Investing in any of these companies assigns a fund a grade of B (assuming there are no investments in producers).';
      var consumersText = 'Consumer goods retailers that source palm oil, paper/pulp, rubber, timber, cattle, and soy from deforestation-risk producers and traders and sell it to consumers worldwide. Investing in any of these companies assigns a fund a grade of B (assuming there are no investments in producers).';

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(name, helmetTitle, url),
        _react2.default.createElement(_components.FundName, {
          shareClass: shareClass,
          pathname: this.props.location.pathname
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'snapshot-wrapper main' },
          _react2.default.createElement(
            'div',
            { styleName: 'snapshot' },
            _react2.default.createElement(_components.Chart, {
              renderBox: (0, _reactCssModules2.default)(renderGradeBox, Styles),
              currency: shareClass.currency,
              invested: _convert2.default.float(shareClass.po_all_asset),
              bankPerc: bankPerc,
              consumerPerc: consumerPerc,
              producerPerc: producerPerc,
              dffPerc: dffPerc,
              producerHoldings: producerHoldings,
              financierHoldings: financierHoldings,
              consumerHoldings: consumerHoldings,
              fHoldingsMap: fHoldingsMap,
              dffAnyAsset: fund.po_all_asset,
              netAsset: fund.fund_net_assets
            }),
            _react2.default.createElement(_components.FlaggedFund, {
              count: _convert2.default.int(shareClass.po_all_count),
              weight: _convert2.default.float(shareClass.po_all_weight)
            }),
            this.hasUssifBadge(fund.ussif) ? this.renderUssifBadge() : null,
            this.renderEngagementStatement(shareClass),
            _react2.default.createElement(
              'div',
              { styleName: 'holdings-count' },
              _react2.default.createElement(
                'div',
                { styleName: 'holdings-count-intro' },
                'This fund contains',
                _react2.default.createElement(
                  'div',
                  { styleName: 'holdings-count-stat ' + color },
                  '\xA0',
                  _format2.default.money(_convert2.default.float(shareClass.po_all_asset), true, shareClass.currency),
                  '\xA0invested\xA0'
                ),
                'in holdings flagged for deforestation risk'
              ),
              hasPetition ? _react2.default.createElement(
                'div',
                { styleName: 'company-snapshot' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'company-intro' },
                  petitionText || defaultCopy
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    title: 'Sign the petition to ask ' + fund_family_name + 'for a No Deforestation Policy',

                    log: _analytics2.default.eventToFamilyTakeAction(name),
                    to: petitionLink,
                    targetBlank: true
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'company-wrapper' },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'company' },
                      buttonText,
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                )
              ) : _react2.default.createElement(
                'div',
                {
                  onClick: this.scrollTo('take-action'),
                  styleName: 'holdings-count-take-action-btn'
                },
                'Take action',
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 4, styleName: 'detail-producers-wrapper' },
                _react2.default.createElement(
                  'div',
                  { styleName: ownsProducers ? 'detail-producers' : 'detail-blank' },
                  _react2.default.createElement('img', {
                    styleName: 'detail-icon',
                    src: producersIcon,
                    alt: 'producers'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-title' },
                    'Commodity producers'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-stat' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      _format2.default.number(shareClass.po_producer_count)
                    ),
                    ' holdings'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-stat' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      _format2.default.perc(shareClass.po_producer_weight)
                    ),
                    ' of assets'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-stat' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      _format2.default.money(shareClass.po_producer_asset, true, shareClass.currency)
                    ),
                    ' invested'
                  )
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 4, styleName: 'detail-banks-wrapper' },
                _react2.default.createElement(
                  'div',
                  { styleName: ownsBanks ? 'detail-banks' : 'detail-blank' },
                  _react2.default.createElement('img', {
                    styleName: 'detail-icon',
                    src: banksIcon,
                    alt: 'banks'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-title' },
                    'Banks and lenders'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-stat' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      _format2.default.number(shareClass.po_financier_count)
                    ),
                    ' holdings'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-stat' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      _format2.default.perc(shareClass.po_financier_weight)
                    ),
                    ' of assets'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-stat' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      _format2.default.money(shareClass.po_financier_asset, true, shareClass.currency)
                    ),
                    ' invested'
                  )
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 4, styleName: 'detail-consumers-wrapper' },
                _react2.default.createElement(
                  'div',
                  { styleName: ownsConsumers ? 'detail-consumers' : 'detail-blank' },
                  _react2.default.createElement('img', {
                    styleName: 'detail-icon',
                    src: consumersIcon,
                    alt: 'consumers'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-title' },
                    'Major consumer brands'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-stat' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      _format2.default.number(shareClass.po_consumer_count)
                    ),
                    ' holdings'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-stat' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      _format2.default.perc(shareClass.po_consumer_weight)
                    ),
                    ' of assets'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-stat' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      _format2.default.money(shareClass.po_consumer_asset, true, shareClass.currency)
                    ),
                    ' invested'
                  )
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'details' },
              this.renderCompanies(shareClass, fHoldingsMap, 'producers', 'Commodity producers', shareClass.po_producer_count, producerHoldings, this.state.producersPage, producersText),
              this.renderCompanies(shareClass, fHoldingsMap, 'banks', 'Banks and lenders', shareClass.po_financier_count, financierHoldings, this.state.banksPage, financierText),
              this.renderCompanies(shareClass, fHoldingsMap, 'consumers', 'Major consumer brands', shareClass.po_consumer_count, consumerHoldings, this.state.consumersPage, consumersText)
            )
          )
        ),
        this.renderMore(shareClass),
        _react2.default.createElement(_components.IyvScorecard, {
          fund: fund,
          shareClass: shareClass
        }),
        _react2.default.createElement(_components.Returns, {
          fund: fund,
          shareClass: shareClass,
          url: url
        }),
        this.renderGraphicBanner(),
        this.renderTakeAction(shareClass)
      );
    }
  }]);
  return Fund;
}(_react.Component), _class2.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class) || _class);
exports.default = Fund;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Fund/Fund.js
// module id = 1320
// module chunks = 0